import classNames from 'classnames';

export interface TagProps {
  label: string;
  textColor?: string;
  className?: string;
  borderColor?: string;
  bgColor?: string;
}

export const Tag = ({ label, textColor, className, borderColor, bgColor }: TagProps) => {
  const defaultBgColor = bgColor ?? 'bg-light-green';
  const defaultBorderClass = borderColor
    ? undefined
    : bgColor === 'bg-white'
      ? 'border-teal-accent'
      : 'border-people-teal-600';
  const borderStyle = borderColor ? { borderColor } : undefined;

  return (
    <span
      className={classNames(
        'inline-flex items-center gap-1 rounded-[8px] border border-dotted bg-white px-[13px] py-[7px] font-haffersq text-sh-12-18 font-normal',
        defaultBgColor,
        defaultBorderClass,
        textColor ?? 'text-black-200',
        className,
      )}
      style={borderStyle}>
      <span>{label}</span>
    </span>
  );
};

export default Tag;
